import { Injectable } from '@angular/core';
import { ReferenceDataConstants, UserSessionService } from 'rome-library';

@Injectable()
export class ExternalUserSessionService extends UserSessionService {
  protected userSessionAboutToExpireDeltaInMinutesConfig =
    ReferenceDataConstants.ExternalUserSessionAboutToExpireDeltaInMinutes;
  protected userSessionDurationInMinutesConfig = ReferenceDataConstants.ExternalUserSessionDurationInMinutes;
}
